class HistoryBack {
    constructor( _alias='', _container='') {
        this.container = _container;
        this.alias = _alias;
    }

    setStorage(_data){
        sessionStorage.setItem(`${this.alias}List`,  JSON.stringify(_data));
    }

    getStorage(){
        return sessionStorage.getItem(`${this.alias}List`);
    }

    removeStorage(){
        //sessionStorage.removeItem(`${this.alias}List`);
        sessionStorage.clear();
    }

    setHistoryBack(option){
        // const data = {
        //     order : option.order || '',
        //     page : option.page || 1,
        //     list : $( this.container ).html(),
        //     query: option.query || '',
        //     isLast: option.isLast
        // }
        const data = $.extend(option, {
            list : $( this.container ).html()
        })
        this.setStorage(data);
    }
} // end of class
export default HistoryBack;
